module.exports = __webpack_public_path__ + "images/external_images/img/1920x800/img1.jpg";